import { forwardRef } from 'react';
import { PiX } from 'react-icons/pi';

import { styled } from '@spazious/dollhouse-theme';
import { IconButton, IconButtonProps } from '@spazious/dollhouse-uikit';

export interface CloseButtonProps extends IconButtonProps {}

/**
 * Close button component for dialogs. It is positioned at the top right corner of the dialog.
 */
export const CloseButton = styled(
  forwardRef<HTMLButtonElement, CloseButtonProps>((props, forwardedRef) => (
    <IconButton ref={forwardedRef} {...props}>
      <PiX />
    </IconButton>
  ))
)`
  position: absolute;
  top: var(--spacing-padding);
  right: var(--spacing-padding);
  z-index: 1;
`;
